import React, {forwardRef} from 'react';

import { NavLink as RouterLink, NavLinkProps } from 'react-router-dom';

const CustomRouterLink = forwardRef<HTMLDivElement, NavLinkProps>((props, ref) => {
  return (
    <div
      ref={ref}
      style={{ flexGrow: 1 }}
    >
      <RouterLink {...props} />
    </div>
  );
});

CustomRouterLink.displayName = 'CustomRouterLink';

export default CustomRouterLink